import { TReduxActions } from '../../types/redux';
import { EActionTypes } from '../../actions/notification';
import { INotificationState } from '../../types/redux/notificator';

export const initialState: INotificationState = {
  isOpen: false,
  content: undefined,
  duration: null,
};

export const notificationReducer = (state = initialState, action: TReduxActions): INotificationState => {
  if (action.type === EActionTypes.SetNotification) {
    return {
      ...state,
      ...action.payload,
    };
  }

  if (action.type === EActionTypes.ClearNotification) {
    /** Поле content не очищаем, чтоб работала анимация */
    return {
      ...state,
      isOpen: false,
      duration: null,
    };
  }

  return state;
};
